export default __webpack_public_path__ + "static/media/Text_Banner_Web-01.fbf8952d.jpg";